import Dexie from 'dexie'
import { fromStore } from 'svelte/store'

const db = new Dexie("shitcoinswap");

db.version(1).stores({
  users: "id",
  balances: "id, user_id, asset_id",
  deposits: "id, user_id, asset_id, wallet_id, amount, confirmations",
  orders: "id, user_id, pair_id",
  quotes: "id, pair_id, side, created_at",
  trades: "id, buyer_id, seller_id, created_at",
})

/**
 * `svelte/store`'s `fromStore`, but for the observables Dexie's `liveQuery`
 * returns: a `{ current }` that follows the table.
 *
 * A liveQuery is not a Svelte store, and `fromStore` cannot tell. It treats
 * whatever `subscribe()` returns as the unsubscribe function, while Dexie hands
 * back its own `{ closed, unsubscribe }` subscription object. Svelte keeps that
 * object as `createSubscriber`'s `stop`, so destroying the last effect that read
 * `.current` throws `stop is not a function` and leaks the subscription. The
 * same mismatch throws in `get(store)`, which dereferences a store by calling
 * that return value directly - so plain `fromStore(liveQuery(...))` is broken
 * both inside and outside an effect. Wrapping the observable in a real store
 * first fixes both.
 *
 * Read `.current` in markup or inside a `$derived` - reading it once at
 * component init warns `state_referenced_locally` and never updates.
 *
 * @template T
 * @param {import('dexie').Observable<T>} observable - e.g. the return value of `liveQuery(...)`
 * @returns {{ readonly current: T | undefined }}
 */
export function fromDexie(observable) {
  return fromStore({
    subscribe(run) {
      const subscription = observable.subscribe(run)
      return () => subscription.unsubscribe()
    }
  })
}

export default db